import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/features/array/from';
import 'core-js/features/array/flat';
import 'core-js/features/set';
import 'core-js/features/promise';
import 'core-js/features/map';
import 'core-js/features/symbol';
import "./assets/scripts/global";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { message, Icon } from "antd";
import { Route, HashRouter } from "react-router-dom";
import { Loading } from "@/components";
import { WXService } from "@/service";
import { handler, useWatchState, state } from "@/store";
import Clipboard from "clipboard";
import Loadable from 'react-loadable';
import registerServiceWorker from "./registerServiceWorker";

import Modals from "./modals";

// antd 国际化
import { LocaleProvider } from 'antd';
import axios from 'axios';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import en_US from 'antd/lib/locale-provider/en_US';
import 'moment/locale/zh-cn';
import { UserService } from '@/service';
import { checkResult } from '@/common';
import 'braft-editor/dist/index.css'

axios.defaults.withCredentials = true;

var clipboard = new Clipboard('.copy');
clipboard.on('success', function (e) {
  message.success("复制成功");
});

const lang = {
  zh: zh_CN,
  en: en_US
}[state.LANG]

// 自动登录
autoLogin()

// 初始化微信 SDK
if (window.wx) {
  WXService.getTicket({ url: encodeURIComponent(window.location.href.split("#")[0]) }).then(res => {
    if (!checkResult(res)) return;

    const ticket = res.data.result;

    const parans = {
      // debug: true,
      appId: 'wx565a510b783f06eb',
      timestamp: ticket.timestamp,
      nonceStr: ticket.noncestr,
      signature: ticket.signature,
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage", "onMenuShareTimeline"] // 必填，需要使用的JS接口列表
    };

    window.wx.config(parans);
    window.wx.error(function (res) {
      message.error("SDK " + JSON.stringify(res))
    });
    window.wx.ready(function () {
    });
  })
}

function autoLogin() {
  // 判断是否自动登录
  const login = localStorage.getItem("login");
  if (!login) return;
  const [account, password, time] = login.split(",");
  UserService.login({
    account,
    password
  }).then(res => {
    if (!checkResult(res)) return;
    handler.login(res.data.result);
  })
}

function FetchLoading() {
  const [[loading]] = useWatchState(["fetchLoading"]);
  return <Icon className={`fetchLoading ${loading && "fetchLoading--show"}`} type="loading" />
}

ReactDOM.render(
  <LocaleProvider locale={lang}>
    <div>
      <Modals />
      <FetchLoading />
      <HashRouter>
        <div>
          {/* 这里不能用列表循环插入，webpack 可能解析不了（猜测） */}
          {/*<Route key="/" exact path="/" component={Loadable({ loader: () => import("./pages/Isefc"), loading: Loading })} />*/}
          {/*<Route key="/" exact path="/" component={Loadable({ loader: () => import("./pages/Home"), loading: Loading })} />*/}
          <Route key="/" exact path="/" component={Loadable({ loader: () => import("./pages/HomeFiveSjz"), loading: Loading })} />
          {/*<Route key="/" exact path="/" component={Loadable({ loader: () => import("./pages/HomeFiveNew"), loading: Loading })} />*/}
          <Route key="/wx" exact path="/wx" component={Loadable({ loader: () => import("./pages/WX"), loading: Loading })} />
          <Route key="/service" exact path="/service" component={Loadable({ loader: () => import("./pages/Service"), loading: Loading })} />
          <Route key="/meetingList/:type" exact path="/meetingList/:type" component={Loadable({ loader: () => import("./pages/MeetingList"), loading: Loading })} />
          <Route key="/emailActive/:account/:code" exact path="/emailActive/:account/:code" component={Loadable({ loader: () => import("./pages/EmailActive"), loading: Loading })} />
          <Route key="/showromm" exact path="/showromm" component={Loadable({ loader: () => import("./pages/Showromm"), loading: Loading })} />
          <Route key="/expert" exact path="/expert" component={Loadable({ loader: () => import("./pages/Expert"), loading: Loading })} />
          <Route key="/expertMore" exact path="/expertMore" component={Loadable({ loader: () => import("./pages/ExpertMore"), loading: Loading })} />
          <Route key="/innovate" exact path="/innovate" component={Loadable({ loader: () => import("./pages/Innovate"), loading: Loading })} />
          <Route key="/organization" exact path="/organization" component={Loadable({ loader: () => import("./pages/Organization"), loading: Loading })} />
          <Route key="/wxBind" exact path="/wxBind" component={Loadable({ loader: () => import("./pages/WXBind"), loading: Loading })} />
          <Route key="/bigdata" path="/bigdata" component={Loadable({ loader: () => import("./pages/Bigdata"), loading: Loading })} />
          <Route key="/cloud/:searchType?" exact path="/cloud/:searchType?" component={Loadable({ loader: () => import("./pages/Cloud"), loading: Loading })} />
          <Route key="/cloudV2/:searchType?" exact path="/cloudV2/:searchType?" component={Loadable({ loader: () => import("./pages/CloudV2"), loading: Loading })} />
          <Route key="/cloudParams/:searchType" exact path="/cloudParams/:searchType" component={Loadable({ loader: () => import("./pages/CloudParams"), loading: Loading })} />
          <Route key="/community" path="/community" component={Loadable({ loader: () => import("./pages/Community"), loading: Loading })} />
          <Route key="/clinic" path="/clinic" component={Loadable({ loader: () => import("./pages/Clinic"), loading: Loading })} />
          <Route key="/clinicCase" path="/clinicCase" component={Loadable({ loader: () => import("./pages/ClinicCase"), loading: Loading })} />
          <Route key="/clinicCaseDetail/:id" path="/clinicCaseDetail/:id" component={Loadable({ loader: () => import("./pages/ClinicCaseDetail"), loading: Loading })} />
          <Route key="/clinicExpert" path="/clinicExpert" component={Loadable({ loader: () => import("./pages/ClinicExpert"), loading: Loading })} />
          <Route key="/clinicResult" path="/clinicResult" component={Loadable({ loader: () => import("./pages/ClinicResult"), loading: Loading })} />
          <Route key="/clinicIntroduce" path="/clinicIntroduce" component={Loadable({ loader: () => import("./pages/ClinicIntroduce"), loading: Loading })} />
          <Route key="/clinicRegister" path="/clinicRegister" component={Loadable({ loader: () => import("./pages/ClinicRegister"), loading: Loading })} />
          <Route key="/course" path="/course" component={Loadable({ loader: () => import("./pages/Course"), loading: Loading })} />
          <Route key="/courseVideo/:cid" path="/courseVideo/:cid" component={Loadable({ loader: () => import("./pages/CourseVideo"), loading: Loading })} />
          <Route key="/courseDetail/:cid" path="/courseDetail/:cid" component={Loadable({ loader: () => import("./pages/CourseDetail"), loading: Loading })} />
          <Route key="/evaluate" path="/evaluate" component={Loadable({ loader: () => import("./pages/Evaluate"), loading: Loading })} />
          {/*<Route key="/home" path="/home" component={Loadable({ loader: () => import("./pages/WebHome"), loading: Loading })} />*/}
          <Route key="/home" path="/home" component={Loadable({ loader: () => import("./pages/HomeFour"), loading: Loading })} />
          <Route key="/homeFiveSjz" path="/homeFiveSjz" component={Loadable({ loader: () => import("./pages/HomeFiveSjz"), loading: Loading })} />
          {/*新版网页首页*/}
          <Route key="/homeFiveNew" path="/homeFiveNew" component={Loadable({ loader: () => import("./pages/HomeFiveNew"), loading: Loading })} />
          <Route key="/evaluateNew" path="/evaluateNew" component={Loadable({ loader: () => import("./pages/EvaluateNew"), loading: Loading })} />

          <Route key="/studio" path="/studio" component={Loadable({ loader: () => import("./pages/Studio"), loading: Loading })} />
          <Route key="/forum" path="/forum" component={Loadable({ loader: () => import("./pages/Forum"), loading: Loading })} />
          {/* <Route key="/login" exact path="/login" component={Loadable({ loader: () => import("./pages/Login"), loading: Loading })} /> */}
          <Route key="/login" exact path="/login" component={Loadable({ loader: () => import("./pages/LoginMember"), loading: Loading })} />
          <Route key="/isefc" exact path="/isefc" component={Loadable({ loader: () => import("./pages/Isefc"), loading: Loading })} />
          <Route key="/isefcSelected" exact path="/isefcSelected" component={Loadable({ loader: () => import("./pages/IsefcSelected"), loading: Loading })} />
          <Route key="/isefcHome" exact path="/isefcHome" component={Loadable({ loader: () => import("./pages/IsefcHome"), loading: Loading })} />
          <Route key="/isefcLogin" exact path="/isefcLogin" component={Loadable({ loader: () => import("./pages/IsefcLogin"), loading: Loading })} />
          <Route key="/isefcAdminLogin" exact path="/isefcAdminLogin" component={Loadable({ loader: () => import("./pages/IsefcAdminLogin"), loading: Loading })} />
          <Route key="/isefcTop" exact path="/isefcTop" component={Loadable({ loader: () => import("./pages/IsefcTop"), loading: Loading })} />
          <Route key="/loginQr" exact path="/loginQr" component={Loadable({ loader: () => import("./pages/LoginQr"), loading: Loading })} />
          {/*<Route key="/register" exact path="/register" component={Loadable({ loader: () => import("./pages/Register"), loading: Loading })} />*/}
          <Route key="/register" exact path="/register" component={Loadable({ loader: () => import("./pages/RegisterMember"), loading: Loading })} />
          <Route key="/isefcRegister" exact path="/isefcRegister" component={Loadable({ loader: () => import("./pages/IsefcRegister"), loading: Loading })} />
          <Route key="/registerMemberSteps/:type" exact path="/registerMemberSteps/:type" component={Loadable({ loader: () => import("./pages/RegisterMemberSteps"), loading: Loading })} />
          <Route key="/memberOrg" exact path="/memberOrg" component={Loadable({ loader: () => import("./pages/MemberOrg"), loading: Loading })} />
          <Route key="/memberCompany" exact path="/memberCompany" component={Loadable({ loader: () => import("./pages/MemberCompany"), loading: Loading })} />
          <Route key="/memberCenter" exact path="/memberCenter" component={Loadable({ loader: () => import("./pages/MemberCenter"), loading: Loading })} />
          <Route key="/retrieve" exact path="/retrieve" component={Loadable({ loader: () => import("./pages/Retrieve"), loading: Loading })} />
          <Route key="/isefcRetrieve" exact path="/isefcRetrieve" component={Loadable({ loader: () => import("./pages/IsefcRetrieve"), loading: Loading })} />
          <Route key="/cheese" exact path="/cheese" component={Loadable({ loader: () => import("./pages/Cheese"), loading: Loading })} />
          <Route key="/markdown" exact path="/markdown" component={Loadable({ loader: () => import("./pages/Markdown"), loading: Loading })} />
          <Route key="/markdown/:id" exact path="/markdown/:id" component={Loadable({ loader: () => import("./pages/Markdown"), loading: Loading })} />
          <Route key="/brandEngineering" path="/brandEngineering" component={Loadable({ loader: () => import("./pages/BrandEngineering"), loading: Loading })} />
          <Route key="/video/:id" exact path="/video/:id" component={Loadable({ loader: () => import("./pages/Video"), loading: Loading })} />
          <Route key="/videoList/:type/:title" exact path="/videoList/:type/:title" component={Loadable({ loader: () => import("./pages/VideoList"), loading: Loading })} />
          <Route key="/resultDetail/:id/:name/:params?" exact path="/resultDetail/:id/:name/:params?" component={Loadable({ loader: () => import("./pages/WXResultDetail"), loading: Loading })} />
          <Route key="/demandDetail/:id/:name/:params?" exact path="/demandDetail/:id/:name/:params?" component={Loadable({ loader: () => import("./pages/WXDemandDetail"), loading: Loading })} />
          <Route key="/wxPushDetail/:pushId/:type/:orgId/:pushGroupId" exact path="/wxPushDetail/:pushId/:type/:orgId/:pushGroupId?" component={Loadable({ loader: () => import("./pages/WXPushDetail"), loading: Loading })} />

          <Route key="/resultSubDetail/:id/:name/:userPushId" exact path="/resultSubDetail/:id/:name/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubResultDetail"), loading: Loading })} />
          <Route key="/demandSubDetail/:id/:name/:userPushId" exact path="/demandSubDetail/:id/:name/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubDemandDetail"), loading: Loading })} />
          <Route key="/wxSubPushList/:type/:userPushId" exact path="/wxSubPushList/:type/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubPushList"), loading: Loading })} />

          <Route key="/resultSubDetailHZ/:id/:userPushId" exact path="/resultSubDetailHZ/:id/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubResultDetailHZ"), loading: Loading })} />
          <Route key="/demandSubDetailHZ/:id/:userPushId" exact path="/demandSubDetailHZ/:id/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubDemandDetailHZ"), loading: Loading })} />
          <Route key="/wxSubPushListHZ/:type/:userPushId" exact path="/wxSubPushListHZ/:type/:userPushId" component={Loadable({ loader: () => import("./pages/WXSubPushListHZ"), loading: Loading })} />

          {/* 需求大赛页面 */}
          <Route key="/ds/:id?" exact path="/ds/:id?" component={Loadable({ loader: () => import("./pages/DemandCompetition"), loading: Loading })} />
          <Route key="/books" exact path="/books" component={Loadable({ loader: () => import("./pages/Books"), loading: Loading })} />
          <Route key="/push" exact path="/push" component={Loadable({ loader: () => import("./pages/Push"), loading: Loading })} />
          <Route key="/pushProfile" exact path="/pushProfile" component={Loadable({ loader: () => import("./pages/PushProfile"), loading: Loading })} />
          <Route key="/pushSecond/:type" path="/pushSecond/:type" component={Loadable({ loader: () => import("./pages/PushSecond"), loading: Loading })} />
          <Route key="/pushDeal" path="/pushDeal" component={Loadable({ loader: () => import("./pages/PushDeal"), loading: Loading })} />
          <Route key="/demandApply/:tab?" exact path="/demandApply/:tab?" component={Loadable({ loader: () => import("./pages/PushDemandApply"), loading: Loading })} />
          <Route key="/demandConfirm/:tab?" exact path="/demandConfirm/:tab?" component={Loadable({ loader: () => import("./pages/PushDemandConfirm"), loading: Loading })} />
          <Route key="/pushDemandOrgAdmin/:tab?" exact path="/pushDemandOrgAdmin/:tab?" component={Loadable({ loader: () => import("./pages/PushDemandOrgAdmin"), loading: Loading })} />
        </div>
      </HashRouter>
    </div>
  </LocaleProvider>,
  document.getElementById("root")
);
registerServiceWorker();
